import { css, styled } from "styled-components";

const Typography = styled.p`
  line-height: ${props => props.$lineHeight ? `var(--line-height-${props.$lineHeight})` : 'inherit'};

  ${(props) => props.fontSize && css`
    font-size: var(--font-size-${props.fontSize});
  `}

  ${(props) => props.$color && css`
    color: var(--color-theme-${props.$color});
  `}
`;

export default Typography;